import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NgClass, NgForOf } from '@angular/common';
import { ModalService } from '@shared/services/modal/modal.service';
import { Table } from '@primeng/table';
import { RouterLink } from '@angular/router';
import { SharedModule } from '@primeng/api';
import { Resources } from '@app/resources';
import { ContractComponent } from '@modules/universal-billing/contract/contract.component';
import { Apartment } from '@modules/universal-billing/apartments/apartments.interface';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseLoadComponent } from '@shared/components/classes/base-load.component';
import { Observable } from 'rxjs';
import { ResidentsService } from '@modules/universal-billing/residents/residents.service';
import { ContractService } from '@modules/universal-billing/contract/contract.service';
import { map } from 'rxjs/operators';
import { RenterNamePipe } from '@common/pipe/renter-name.pipe';
import { ModalClose } from '@shared/services/modal/modal.enum';

@Component({
  selector: 'apartment-contracts',
  standalone: true,
  imports: [
    TranslatePipe,
    NgForOf,
    NgClass,
    Table,
    RouterLink,
    SharedModule,
    RenterNamePipe
  ],
  templateUrl: './apartment-contracts.component.html',
  styleUrl: './apartment-contracts.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class ApartmentContractsComponent extends BaseLoadComponent<any>{
  @Input() apartment: Apartment;
  readonly TABS = [
    {key: 'FUTURE_USE', label: 'Future use', icon: 'la la-calendar-plus'},
    {key: 'CURRENT_USAGE', label: 'Current usage', icon: 'la la-bolt'},
    {key: 'PAST_USE', label: 'Past use', icon: 'la la-history'}
  ];
  service = inject(ContractService);

  activeTab: string = 'CURRENT_USAGE';

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }

  modalService = inject(ModalService);
  ngbModal = inject(NgbModal);
  translate = inject(TranslateService);

  apartmentContracts = [];

  addContract() {
    // const dialogRef = this.ngbModal.open(ContractComponent, {
    //   size: 'xl',
    // })
    this.modalService.open({
      title: '',
      component: ContractComponent,
      modalOptions: {
        size: 'xl',
        withoutBody: true
      },
      componentOptions: {
        apartment: this.apartment,
      }
    }).then(value => {
      if (value == ModalClose.SUCCESS) {
        this.loadData();
      }
    })
    // dialogRef.componentInstance.apartment = this.apartment;
  }

  protected readonly Resources = Resources;

  getData(): Observable<any> {
    return this.service.getAll({ apartmentId: this.apartment.id }).pipe(map(data=> {
      this.apartmentContracts = data.data;
    }));
  }
}
